const commonityFeedback = {
  // 提交社区反馈(老 不用了)
  giveFeedbackForForumd: `/forumApi/v1/Feedback/giveFeedbackForForum`,
  // 提交社区反馈(新)
  giveFeedback: `/forumApi/v1/Feedback/giveFeedback`,
  // 获取反馈分类
  classList: `/forumApi/v1/Feedback/classList`,
  // 上传反馈图片或视频
  uploadFile: `/forumApi/v1/Feedback/uploadFile`,
  // 官方回复列表
  officialReplyList: `/forumApi/v1/Feedback/officialReplyList`,
  // 我的反馈列表
  myFeedbackList: `/forumApi/v1/Feedback/myFeedbackList`,
  // 最新反馈列表
  latestFeedbackList: `/forumApi/v1/Feedback/latestFeedbackList`,
  // 回复社区反馈
  replyFeedback: `/forumApi/v1/Feedback/replyFeedback`
};

export default commonityFeedback;
